<template>
  <div v-if="option.show" class="bs-index-tree">
    <el-tree
        style="background: transparent"
        :data="option.loopVariable || []"
        default-expand-all
        highlight-current
        node-key="id"
    >
      <template v-slot:default="{ node, data }">
        <div
            @dragstart="
                        (e) => {
                      option.dragStart(e, data, 1);
                    }
                    "
            :draggable="option.draggable(node, data)"
            @dragend="option.dragEnd()"
            class="flex customTree-wrapper pr-10 move"
        >
          <div
              class="seltree_content ellipse-name-right"
              :title="data.name"
          >
            <svg-icon
                color="#878f95"
                class="text m mr-4"
                :icon-class="getIcon(data.fieldType)"
            />
            {{ data.name }}
          </div>
        </div>
      </template>
    </el-tree>
  </div>
</template>
<script setup>
import {MODEL_COLUMN_TYPE, METRIC_TYPE} from "@/option/common/dict.js";

let props = defineProps({
  option: {},
  linkData: {
    default() {
      return {};
    },
  },
})

function getIcon(type) {
  switch (type) {
    case MODEL_COLUMN_TYPE.date:
      return "date";
    case MODEL_COLUMN_TYPE.number:
      return "123";
    case METRIC_TYPE.CUS:
      return "fx";
    default:
      return "abc";
  }
}
</script>

<style lang="scss">
@import "@/styles/variables";

.bs-index-tree .el-tree-node {
  padding: 2px 4px;
  border-radius: 4px;
  margin-bottom: 4px;
  background: $mainbgColor;
}
</style>
<style scoped lang="scss">
@import "@/styles/variables";

:deep(.seltree_content) {
  white-space: normal;
  word-break: break-all;
}

:deep(.bs-index-tree .el-tree-node) {
  padding: 2px 4px;
  border-radius: 4px;
  margin-bottom: 4px;
  background: $mainbgColor;
}

.bs-index-tree {
  .ellipse-name-right {
    font-size: 12px;
    max-width: 146px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    color: rgb(96, 98, 102);

    svg {
      font-size: 12px;
    }
  }
}

</style>